export const getTimeWindow = (location) => {
  let timeWindow = "";

  if (location.arrival_time) {
    timeWindow = location.arrival_time;
  }
  if (location.finish_time) {
    timeWindow = location.finish_time;
  }
  if (location.arrival_time && location.finish_time) {
    timeWindow = `${location.arrival_time} - ${location.finish_time}`;
  }

  return timeWindow;
};

export const parseLocationIdentifier = (locationId) => {
  // Split the string by underscore
  const parts = locationId.split("_");
  let locationType = "";
  // The locationType is always the last part
  if (parts.length > 1) {
    locationType = parts.pop();
  }

  // The remaining parts form the baseId
  const baseId = parts.join("_");

  return { baseId, locationType };
};

export const getLocationTypeString = (location) => {
  if (Array.isArray(location.type)) {
    return location.type.join(", ");
  } else if (typeof location.type === "string") {
    return location.type;
  }
  return "";
};
